module.exports = __webpack_public_path__ + "static/media/anc5ru.636ad2db.pdf";